/* Same normalized modal projection, without transient per-grain arrays. */
(()=>{
  function buildTargets(base,aspect,modes){
    const count=base.length/2,targets=modes.map(()=>new Float32Array(count*2));
    // Normalized |Psi|² and its gradient from the article's modal expansion.
    const resolution=224,width=Math.PI*aspect,height=Math.PI;
    modes.forEach((spec,k)=>{
      const field=window.DMModalStudy.buildField(width,height,resolution,spec),dest=targets[k];
      for(let i=0;i<count;i++){
        let x=base[i*2]*width,y=base[i*2+1]*height;
        for(let iteration=0;iteration<32;iteration++){
          const gx=x/width*(resolution-1),gy=y/height*(resolution-1),ix=Math.min(resolution-2,Math.floor(gx)),iy=Math.min(resolution-2,Math.floor(gy)),fx=gx-ix,fy=gy-iy;
          const j=(iy*resolution+ix)*3;let f,dx,dy;
          for(let c=0;c<3;c++){const value=(field[j+c]*(1-fx)+field[j+3+c]*fx)*(1-fy)+(field[j+resolution*3+c]*(1-fx)+field[j+(resolution+1)*3+c]*fx)*fy;if(c===0)f=value;else if(c===1)dx=value;else dy=value;}
          if(f<.0012)break;
          const step=Math.min(.028,(f-.0008)/(dx*dx+dy*dy+.0001));
          x=Math.max(.001,Math.min(width-.001,x-dx*step));y=Math.max(.001,Math.min(height-.001,y-dy*step));
        }
        const loose=i%12===0;
        dest[i*2]=loose?base[i*2]*aspect:x/Math.PI;
        dest[i*2+1]=loose?base[i*2+1]:y/Math.PI;
      }
    });
    return targets;
  }

self.DMTargetFields={buildTargets};
})();
